/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDiscreteNumericListDtoGeometry } from './CreateDiscreteNumericListDtoGeometry';
import {
    CreateDiscreteNumericListDtoGeometryFromJSON,
    CreateDiscreteNumericListDtoGeometryFromJSONTyped,
    CreateDiscreteNumericListDtoGeometryToJSON,
} from './CreateDiscreteNumericListDtoGeometry';
import type { CreateNumericEvaluationParameterDtoDefinition } from './CreateNumericEvaluationParameterDtoDefinition';
import {
    CreateNumericEvaluationParameterDtoDefinitionFromJSON,
    CreateNumericEvaluationParameterDtoDefinitionFromJSONTyped,
    CreateNumericEvaluationParameterDtoDefinitionToJSON,
} from './CreateNumericEvaluationParameterDtoDefinition';
import type { CreateNumericEvaluationParameterDtoEvaluationType } from './CreateNumericEvaluationParameterDtoEvaluationType';
import {
    CreateNumericEvaluationParameterDtoEvaluationTypeFromJSON,
    CreateNumericEvaluationParameterDtoEvaluationTypeFromJSONTyped,
    CreateNumericEvaluationParameterDtoEvaluationTypeToJSON,
} from './CreateNumericEvaluationParameterDtoEvaluationType';
import type { CreateNumericEvaluationParameterDtoLimitType } from './CreateNumericEvaluationParameterDtoLimitType';
import {
    CreateNumericEvaluationParameterDtoLimitTypeFromJSON,
    CreateNumericEvaluationParameterDtoLimitTypeFromJSONTyped,
    CreateNumericEvaluationParameterDtoLimitTypeToJSON,
} from './CreateNumericEvaluationParameterDtoLimitType';

/**
 * 
 * @export
 * @interface CreateNumericEvaluationParameterDto
 */
export interface CreateNumericEvaluationParameterDto {
    /**
     * 
     * @type {string}
     * @memberof CreateNumericEvaluationParameterDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNumericEvaluationParameterDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateNumericEvaluationParameterDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateNumericEvaluationParameterDto
     */
    allowRepetition?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateNumericEvaluationParameterDto
     */
    instruction?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateNumericEvaluationParameterDto
     */
    upperWarningLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateNumericEvaluationParameterDto
     */
    upperFailedLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateNumericEvaluationParameterDto
     */
    lowerFailedLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateNumericEvaluationParameterDto
     */
    lowerWarningLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateNumericEvaluationParameterDto
     */
    min?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateNumericEvaluationParameterDto
     */
    max?: number | null;
    /**
     * 
     * @type {CreateDiscreteNumericListDtoGeometry}
     * @memberof CreateNumericEvaluationParameterDto
     */
    geometry?: CreateDiscreteNumericListDtoGeometry | null;
    /**
     * 
     * @type {CreateNumericEvaluationParameterDtoDefinition}
     * @memberof CreateNumericEvaluationParameterDto
     */
    definition?: CreateNumericEvaluationParameterDtoDefinition | null;
    /**
     * 
     * @type {CreateNumericEvaluationParameterDtoDefinition}
     * @memberof CreateNumericEvaluationParameterDto
     */
    definitionParameterValueSet?: CreateNumericEvaluationParameterDtoDefinition | null;
    /**
     * 
     * @type {CreateNumericEvaluationParameterDtoEvaluationType}
     * @memberof CreateNumericEvaluationParameterDto
     */
    evaluationType?: CreateNumericEvaluationParameterDtoEvaluationType | null;
    /**
     * 
     * @type {CreateNumericEvaluationParameterDtoLimitType}
     * @memberof CreateNumericEvaluationParameterDto
     */
    limitType?: CreateNumericEvaluationParameterDtoLimitType | null;
    /**
     * 
     * @type {number}
     * @memberof CreateNumericEvaluationParameterDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateNumericEvaluationParameterDto
     */
    $type?: CreateNumericEvaluationParameterDtoTypeEnum;
}


/**
 * @export
 */
export const CreateNumericEvaluationParameterDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoEvaluationParametersCreateNumericEvaluationParameterDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.CreateNumericEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateNumericEvaluationParameterDtoTypeEnum = typeof CreateNumericEvaluationParameterDtoTypeEnum[keyof typeof CreateNumericEvaluationParameterDtoTypeEnum];


/**
 * Check if a given object implements the CreateNumericEvaluationParameterDto interface.
 */
export function instanceOfCreateNumericEvaluationParameterDto(value?: unknown): value is CreateNumericEvaluationParameterDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateNumericEvaluationParameterDtoTypeEnum)[0];
}

export function CreateNumericEvaluationParameterDtoFromJSON(json: any): CreateNumericEvaluationParameterDto {
    return CreateNumericEvaluationParameterDtoFromJSONTyped(json, false);
}

export function CreateNumericEvaluationParameterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNumericEvaluationParameterDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'allowRepetition': !exists(json, 'allowRepetition') ? undefined : json['allowRepetition'],
        'instruction': !exists(json, 'instruction') ? undefined : json['instruction'],
        'upperWarningLimit': !exists(json, 'upperWarningLimit') ? undefined : json['upperWarningLimit'],
        'upperFailedLimit': !exists(json, 'upperFailedLimit') ? undefined : json['upperFailedLimit'],
        'lowerFailedLimit': !exists(json, 'lowerFailedLimit') ? undefined : json['lowerFailedLimit'],
        'lowerWarningLimit': !exists(json, 'lowerWarningLimit') ? undefined : json['lowerWarningLimit'],
        'min': !exists(json, 'min') ? undefined : json['min'],
        'max': !exists(json, 'max') ? undefined : json['max'],
        'geometry': !exists(json, 'geometry') ? undefined : CreateDiscreteNumericListDtoGeometryFromJSON(json['geometry']),
        'definition': !exists(json, 'definition') ? undefined : CreateNumericEvaluationParameterDtoDefinitionFromJSON(json['definition']),
        'definitionParameterValueSet': !exists(json, 'definitionParameterValueSet') ? undefined : CreateNumericEvaluationParameterDtoDefinitionFromJSON(json['definitionParameterValueSet']),
        'evaluationType': !exists(json, 'evaluationType') ? undefined : CreateNumericEvaluationParameterDtoEvaluationTypeFromJSON(json['evaluationType']),
        'limitType': !exists(json, 'limitType') ? undefined : CreateNumericEvaluationParameterDtoLimitTypeFromJSON(json['limitType']),
        'decimalPlaces': !exists(json, 'decimalPlaces') ? undefined : json['decimalPlaces'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateNumericEvaluationParameterDtoToJSON(value?: CreateNumericEvaluationParameterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'dataTypeId': value.dataTypeId,
        'isEnabled': value.isEnabled,
        'allowRepetition': value.allowRepetition,
        'instruction': value.instruction,
        'upperWarningLimit': value.upperWarningLimit,
        'upperFailedLimit': value.upperFailedLimit,
        'lowerFailedLimit': value.lowerFailedLimit,
        'lowerWarningLimit': value.lowerWarningLimit,
        'min': value.min,
        'max': value.max,
        'geometry': CreateDiscreteNumericListDtoGeometryToJSON(value.geometry),
        'definition': CreateNumericEvaluationParameterDtoDefinitionToJSON(value.definition),
        'definitionParameterValueSet': CreateNumericEvaluationParameterDtoDefinitionToJSON(value.definitionParameterValueSet),
        'evaluationType': CreateNumericEvaluationParameterDtoEvaluationTypeToJSON(value.evaluationType),
        'limitType': CreateNumericEvaluationParameterDtoLimitTypeToJSON(value.limitType),
        'decimalPlaces': value.decimalPlaces,
        '$type': value.$type,
    });
}

